import styled from 'styled-components';
import { ComplexIconSizesType } from '../ThemeProvider/types';

export const SvgContainer = styled.div<{
  size: ComplexIconSizesType;
  color: string;
  clickable: boolean;
  disabled: boolean;
}>`
  align-items: center;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
  display: flex;
  height: ${({ theme, size }) => theme.complexIcon[size].size}px;
  justify-content: center;
  width: ${({ theme, size }) => theme.complexIcon[size].size}px;

  & > svg path:not([class$='not-color']),
  & > svg circle:not([class$='not-color']),
  & > svg rect:not([class$='not-color']) {
    stroke: ${({ color, disabled, theme }) => (disabled ? theme.grayCC : color)};
    stroke-width: ${({ theme, size }) => theme.complexIcon[size].stroke}px;
  }
`;
